import { SearchPaginationQuery } from './';
import api from './_client';

export type ListPayload = SearchPaginationQuery;

export interface IdPayload {
    id: string;
}

export interface DataPayload {
    id?: string;
    data: any;
}
export const list = (payload: ListPayload) => api.get(`/sections`, { params: payload });

export const details = (payload: IdPayload) => api.get(`/section/${payload.id}`);

export const create = (payload: DataPayload) => api.post(`/section`, payload.data);

export const update = (payload: DataPayload) => api.put(`/section/${payload.id}`, payload.data);

export const del = (payload: IdPayload) => api.delete(`/section/${payload.id}`);
